export default "__VITE_ASSET__BMTapo5K__"